<div class="popup address-browsing" [ngClass]="showZip==true ? 'opened' : ''">
  <div class="container default-container popup-content">
    <div class="popup-header row">
      <h2 class="col h-medium">주소 검색</h2>
      <a href="javascript:;" class="col-auto close-popup-btn"
        (click)="handleOnClickCloseZipPopup();">
        <svg width="22" height="22" viewBox="0 0 22 22">
          <path d="M1 1L21 21" />
            <path d="M21 1L1 21" />
            </svg>
          </a>
        </div>
        <div class="popup-body">
          <div class="searching-form">
            <div class="container default-container">
              <div class="row form-row">
                <!-- Member Name -->
                <div class="col col-sm info member-name row">
                  <!-- <span class="col-sm-auto label"></span> -->
                  <input class="col-sm" placeholder="" [(ngModel)]="value"
                    (keydown.enter)="handleOnClickSearch()">
                </div>
                <div class="col-sm-auto submit-btn"
                  (click)="handleOnClickSearch();">검색</div>
              </div>
            </div>
          </div>

          <div class="container default-container results">
            <div class="table-container">
              <table class="hr-table">
                <thead>
                  <tr>
                    <th style="width: 45px;">NO</th>
                    <th style="width: 67px;">우편번호</th>
                    <th>주소</th>
                    <th>지번</th>
                  </tr>
                </thead>
                <tbody id="tableZipcode">
                  <ng-container *ngIf="total>0">

                    <tr *ngFor="let item of items  | paginate: config ;let i=index"  (click)="handleOnClickRow(item) ">
                      <td style="text-align: center;">{{(i+1)+(page-1)*10}}</td>
                      <td style="text-align: center;">{{ item.address }}</td>

                      <td style="text-align: center;">{{ item.zipCode }}</td>
                      <td style="text-align: center;">{{ item.jibun }}</td>
                    </tr>
                  </ng-container>
                  <ng-container *ngIf="total==0">
                    
                  <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                  <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                  <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;<span
                   class="empty-warning h-small">조회된 데이타가 없습니다.</span></td><td>&nbsp;</td></tr>
                   <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                   <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
                  </ng-container>

                  </tbody>
             
                      </table>
            </div>
            <paging [len]="len"
            [page]="page" 
            [config]="config" 
            [totalItems]="total"                
            (changePage)="handleOnChangePage($event)" 
            (totalPage)="onTotalPage($event)"              
            (changeLen)="handleOnChangeSelected($event)" 
            [turnOnTotalPage]="true"               
            [turnOnPagination]="true" 
            [turnOnTotalItem]="true" 
            [isMobile]="false">
           </paging>
          </div>
        </div>
      </div>
    </div>